import { setCustomRules } from './setCustomRules';
import { setMessageRules } from './setMessageRules';

export const initSettingsVeeValidate = () => {
  setCustomRules();
  setMessageRules();
};
